import { render, staticRenderFns } from "./BookingConfirmation.vue?vue&type=template&id=1d6b4a63&scoped=true&"
import script from "./BookingConfirmation.vue?vue&type=script&lang=js&"
export * from "./BookingConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./BookingConfirmation.vue?vue&type=style&index=0&id=1d6b4a63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6b4a63",
  null
  
)

export default component.exports